import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MakiIconsService {

  constructor(
    private http: HttpClient
  ) { }

  getIcons(): Observable<any> {
    return this.http.get('assets/maki/layouts/streets.json');
  }
}
